import ReactDOM from 'react-dom'

import { parseJSONFromScript } from '../shared/parseJSONFromScript'
import Canvas from './components/Canvas'
import { MAP_SUBTYPES_COMPANIES_BY_ID } from './constants/constants'
import { SettingsSmall, SettingsSmallDark, SettingsSmallGeo, SettingsSmallGeoDark } from './constants/settings'
import Treemap from './treemap'
import { MapSubtypeId, MapTypeId, PerfData } from './types'
import * as mapUtils from './utils'

const CANVAS_WIDTH = 400
const CANVAS_HEIGHT_GEO = 235
const CANVAS_HEIGHT = 300
const CANVAS_HEIGHT_NEW = 368

async function renderTreemaps(props: { perfDataSec: PerfData; perfDataGeo: PerfData; cacheBuster: number }) {
  let precomputedData
  try {
    precomputedData = await mapUtils.fetchBaseData(
      FinvizSettings.hasRedesignEnabled ? 'hp_redesign.json' : 'hp.json',
      props.cacheBuster
    )
  } catch {
    return
  }
  const isDark = document.documentElement.classList.contains('dark')

  if (props.perfDataSec) {
    const subtype = MAP_SUBTYPES_COMPANIES_BY_ID[MapSubtypeId.DayPerf]
    const scale = { id: subtype.scaleId, name: subtype.name, tooltip: subtype.tooltip }
    const initData = mapUtils.getMapData(precomputedData.sec, props.perfDataSec)
    const treemap = new Treemap({
      data: initData,
      scale,
      width: CANVAS_WIDTH,
      height: FinvizSettings.hasRedesignEnabled ? CANVAS_HEIGHT_NEW : CANVAS_HEIGHT,
      countIndustryPerf: false,
      countSectorPerf: true,
      settings: isDark ? SettingsSmallDark : SettingsSmall,
      type: MapTypeId.Sector,
      subtype: subtype.id,
      isSmall: true,
      zoomLevels: [1],
    })

    window.FinvizIndexSecMap = treemap

    ReactDOM.render(
      <Canvas treemap={treemap} hover={false} legend={false} zoom={false} alt="S&P 500 Map" />,
      document.getElementById('treemap-small')
    )
  }

  if (props.perfDataGeo) {
    const subtype = MAP_SUBTYPES_COMPANIES_BY_ID[MapSubtypeId.DayPerf]
    const scale = { id: subtype.scaleId, name: subtype.name, tooltip: subtype.tooltip }
    const initData = mapUtils.getMapData(precomputedData.geo, props.perfDataGeo)
    const treemap = new Treemap({
      data: initData,
      scale,
      width: CANVAS_WIDTH,
      height: CANVAS_HEIGHT_GEO,
      countIndustryPerf: true,
      countSectorPerf: false,
      settings: isDark ? SettingsSmallGeoDark : SettingsSmallGeo,
      type: MapTypeId.World,
      subtype: subtype.id,
      isSmall: true,
      zoomLevels: [1],
    })

    window.FinvizIndexGeoMap = treemap

    ReactDOM.render(
      <Canvas treemap={treemap} hover={false} legend={false} zoom={false} alt="World Map" />,
      document.getElementById('treemap-small-geo')
    )
  }
}

const mapProps = parseJSONFromScript<{ perfDataSec: PerfData; perfDataGeo: PerfData; cacheBuster: number }>('map-data')
if (mapProps) renderTreemaps(mapProps)
